

















































































import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';

interface FullMarkData {
  checkTextStr: string,
  activeIndex: number,
  fragment: any,
  fragmens: any,
  fragmentStr: string,
  init: boolean,
  pickUp: number,
  newGroupList: any,
  indexList: any
}

export default Vue.extend({
  name: 'FullTextMark',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText
  }),
  watch: {
    checkInfo(newVal, oldVal) {
      this.initOriginalTextMark();
    },
    checkText(newVal, oldVal) {
      this.initOriginalTextMark();
    }
  },
  data(): FullMarkData {
    return {
      checkTextStr: '',
      activeIndex: 0,
      fragment: {},
      fragmens: [],
      fragmentStr: '',
      init: false,
      pickUp: 0,
      newGroupList: [],
      indexList: [[]]
    };
  },
  methods: {
    // 标记字的索引信息转成段落
    divideSection(list: number[]) {
      const section: any = [];
      list.forEach((item: number, index: number) => {
        if (section.length && (list[index] - section[section.length - 1].beginIndex) === 1) {
          section[section.length - 1].beginIndex = list[index];
          section[section.length - 1].length = section[section.length - 1].length + 1;
        } else {
          section.push({
            beginIndex: list[index],
            begin: list[index],
            length: 1
          });
        }
      });
      return section;
    },
    initIndexList() {
      this.indexList = [{len: 0, arr: []}];
      this.newGroupList = [[]];
      let fragmentCombinee = this.checkInfo.fragmentCombine || '';
      let group = fragmentCombinee.split(/,|;|:/);
      group.forEach((it: any, ind: any) => {
        if(fragmentCombinee.includes(`:${it};`) || fragmentCombinee.includes(`:${it}:`) || fragmentCombinee.includes(`:${it},`) || (ind == group.length - 1 && fragmentCombinee.includes(`:${it}`))) {
          this.indexList[this.indexList.length-1].arr[this.indexList[this.indexList.length-1].arr.length - 1].push(this.checkInfo.hitDetailInfoList[it]);
          this.newGroupList[this.newGroupList.length-1][this.newGroupList[this.newGroupList.length-1].length-1].push(it);
        } else {
          this.indexList[this.indexList.length-1].arr.push([this.checkInfo.hitDetailInfoList[it]]);
          this.newGroupList[this.newGroupList.length-1].push([it]);
        }
        this.indexList[this.indexList.length-1].len += this.checkInfo.hitDetailInfoList[it].similarLength;
        if(fragmentCombinee.includes(`,${it};`) || fragmentCombinee.includes(`:${it};`) || fragmentCombinee.includes(`;${it};`) || (ind == 0 && fragmentCombinee.substring(0,2) === '0;')) {
          this.indexList.push({len: 0, arr: []});
          this.newGroupList.push([])
        }
      });
    },
    // 初始化原文
    initOriginalTextMark() {
      const checkText = this.checkText
      .replace(/</g, '＜')
      .replace(/>/g, '＞')
      || '';
      const problemList = this.checkInfo.hitDetailInfoList || [];
      problemList.length ? this.initIndexList() : '';
      // 报告字符串转换成数组
      let checkTextArry = checkText.split('');
      this.checkTextStr = '';
      // 偏移量
      let offset = 0;
       
      // checkTextArry = checkTextArry.map((item: any) => {
      //    return item.replace(/</gi, "＜").replace(/>/gi, "＞");
      // });

      problemList.forEach((item: any, index: number) => {
        let hitText = checkText.substr(item.beginPosition, item.length) || '';
        // 标注颜色
        let eClass = 'red';
        // 根据不同的状态显示不同的颜色
        if (item.isSelfCited) {
          eClass = 'yellow ';
        } else if (item.isReference) {
          eClass = 'green';
        } else if(item.isLaw) {
          eClass = 'deepblue ';
        }

        const section = this.divideSection(item.originalChars);
        // 按字标记
        const hitTextArry = hitText.split('');
        // 按字标记
        let hitStr = '';
        let flag = false;
        hitTextArry.forEach((items:any,index1:number)=>{
          if (item.originalChars.indexOf(item.beginPosition + index1) != -1){
            if(flag) {
              hitStr +=  items;
            }else {
              hitStr += `<span e-index="${index}" class="${eClass}">${items}`;
              flag = true;
            }
          }else{
            if(flag){
              hitStr +=  `</span>${items}`;
              flag = false;
            }else {
              hitStr += items;
            }
          }
          // 如果是相似文本且出现在最后一位自动补全span的闭合标签
          if(hitTextArry.length == index1+1){
            hitStr +=  '</span>'
          }
        })
        // let hitOffset = 0;
        // section.forEach((items: any) => {
        //   const hitWord = hitText.substr(items.begin - item.beginPosition - hitOffset, items.length);
        //   hitTextArry.splice(items.begin - item.beginPosition - hitOffset, items.length, `<span e-index=${index} class="${eClass}">${hitWord}</span>`);
        //   // 按字标的偏移量
        //   hitOffset = hitOffset + items.length - 1;
        // });
        // hitText = hitTextArry.join('');

        // 根据位置替换相似片段
        checkTextArry.splice(item.beginPosition - offset, item.length, `<span e-index=${index} id="vecFragment${index}" class="cursor" e-type="section">${hitStr}</span>`);
        // 报告数组的偏移量
        // console.log(item.length +'----' +offset)
        offset = offset + item.length-1;
      });
      this.checkTextStr = checkTextArry.join('');
      this.checkTextStr = this.checkTextStr.replace(/\r\n/g, '<br />').replace(/\r/g, '<br />').replace(/\n/g, '<br />');
    },
    initFragments() {
      // [[7],[8,9,10],[11]]
      this.fragmens.forEach((ittt: any) => {
        let countNum = 0;
        ittt.forEach((it: any) => {
          this.init = true;
          if (!it.hasCopyRight) {
            it.fragmentStr = '';
            return false;
          }
          countNum += it.similarLength;
          it.countNum = countNum;
          it.fragmentStr = it.hitText || '';
          // 按字标记
          const checkTextArry = it.fragmentStr.split('');
          let hitStr = '';
          let flag = false;
          checkTextArry.forEach((items:any,index:number)=>{
            if (it.similarChars.indexOf(it.hitBeginPosition + index) != -1){
              if(flag) {
                hitStr +=  items;
              }else {
                hitStr += `<span class="red">${items}`;
                flag = true;
              }
            }else{
              if(flag){
                hitStr +=  `</span>${items}`;
                flag = false;
              }else {
                hitStr += items;
              }
            }
          })
          it.fragmentStr = hitStr;
        });
      });
    },
    // 初始化相似文献片段
    initFragment() {
      this.init = true;
      if (!(this.fragment as any).hasCopyRight) {
        this.fragmentStr = '';
        return false;
      }
      this.fragmentStr = (this.fragment as any).hitText || '';
      // 按字标记
      const checkTextArry = this.fragmentStr.split('');
      let hitStr = '';
      let flag = false;
      checkTextArry.forEach((items:any,index:number)=>{
        if ((this.fragment as any).similarChars.indexOf((this.fragment as any).hitBeginPosition + index) != -1){
          if(flag) {
            hitStr +=  items;
          }else {
            hitStr += `<span class="red">${items}`;
            flag = true;
          }
        }else{
          if(flag){
            hitStr +=  `</span>${items}`;
            flag = false;
          }else {
            hitStr += items;
          }
        }
      })
      this.fragmentStr = hitStr;
    },
    handleChangeFold(index: number, type: boolean) {
      this.pickUp = type ? index : -1;
    },
    // 选择纠错片段
    selectVecFragment(action: string, ele: any) {
      const target = ele.target;
      const targetName = target.nodeName;
      if (ele.target && ele.target.getAttribute('e-index') !== null) {
        this.activeIndex = ele.target.getAttribute('e-index');
        this.fragmens = [];
        let currActiveArr: any[] = [];
        this.newGroupList.forEach((it: any, i: any) => {
          it.map((elm: any, ind: any) => {
            if(elm.indexOf(this.activeIndex) !== -1) {
              currActiveArr = [].concat.apply([], it);
              this.pickUp = ind;
              this.fragmens = this.indexList[i].arr;
  
            }
          });
        });
        // this.fragment = this.checkInfo.hitDetailInfoList[this.activeIndex];
        this.initFragments();

        if (targetName.toUpperCase() === 'SPAN') {
          document.querySelectorAll('span[e-type]').forEach((item, index) => {
            const element = item;
            let elementClass = element.className;
            if (currActiveArr.indexOf(String(index)) !== -1) {
              if (element) {
                const elements = element.querySelectorAll('span');
                elements.forEach((items, indexs) => {
                  const elementsClass = elements[indexs].className;
                  elements[indexs].className = elementsClass + ' blue ';
                });
                element.className = elementClass + ' blue ';
              }
            } else {
              if (element) {
                elementClass = elementClass.replace(/ blue/g, '');
                element.className = elementClass;
                const elements = element.querySelectorAll('span');
                elements.forEach((items, indexs) => {
                  const elementsClass = elements[indexs].className.replace(/ blue/g, '');
                  elements[indexs].className = elementsClass;
                });
              }
            }
          });
        }



      }
    }
  },
  mounted() {
    if (this.checkInfo.hitDetailInfoList && this.checkText) {
      this.initOriginalTextMark();
    }
  }
});
